const SupportingDocumentTodoType = {
  SET_SUPPORTING_DOCUMENT_TODO_LIST: 'SET_SUPPORTING_DOCUMENT_TODO_LIST',
  SET_FILTER_SORT_DATA: 'SUPPORTING_DOC_TODO_SET_FILTER_SORT_DATA',
  BULK_DELETE_SUPPORTING_DOCUMENTS: 'BULK_DELETE_SUPPORTING_DOCUMENTS',
};

export default SupportingDocumentTodoType;
